import { ReactNode } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuthentication } from "../hooks/useAuthentication";
import { useLinks } from "../hooks/useLinks";

export type AuthenticatedGuardProps = {
  children?: ReactNode;
};

export const redirectPathKey = "redirectPath";

export const AuthenticatedGuard = (props: AuthenticatedGuardProps) => {
  const { children } = props;
  const { isAuthenticated, isSetupFinished, isLoading } = useAuthentication();
  const links = useLinks();
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const redirectPath =
    `${location.pathname}${location.search}${location.hash}` || links.home();

  if (!isAuthenticated) {
    sessionStorage.setItem(redirectPathKey, redirectPath);
    return <Navigate replace to={links.login()} />;
  }

  if (!isSetupFinished && !isLoading && pathname !== links.companySignUp()) {
    navigate(links.companySignUp());
  }

  return <>{children}</>;
};
